export default {
  message: {
    "strid1": "Permohonan Perizinan Lisensi Turnamen Besar",
    "strid2": "Email",
    "strid3": "Kode Verifikasi Email",
    "strid4": "Nama Turnamen",
    "strid5": "Pengenalan Singkat Mengenai Turnamen",
    "strid6": "Waktu Mulai Turnamen",
    "strid7": "Waktu Selesai Turnamen",
    "strid8": "Turnamen ini diadakan secara Online atau Offline",
    "strid9": "Online",
    "strid10": "Offline",
    "strid11": "Meliputi tahap Online dan Offline",
    "strid12": "Informasi Kontak Lainnya",
    "strid14": "Silakan tulis informasi kontak Anda (WhatsApp/Instagram/Facebook/Email, dll.)",
    "strid16": "Nama Anda",
    "strid17": "Penyelenggara",
    "strid18": "Pelaksana",
    "strid19": "Lainnya",
    "strid20": "Kirim",
    "strid21": "Kembali",
    "strid23": "Kirim",
    "strid24": "Cari",
    "strid25": "Mohon konfirmasi alamat Email Anda dengan kode verifikasi {}",
    "strid26": "Ini adalah pesan otomatis, mohon jangan dibalas. Anda menerima Email ini karena Anda mengajukan permohonan di situs Web Pengajuan Turnamen Pihak Ketiga kami.",
    "strid27": "Silakan masukkan Email pemohon untuk mencari",
    "strid28": "Kode verifikasi Email",

    "strid29": "Silakan baca Syarat dan Ketentuan berikut",
    "strid30": "Lanjutkan",
    "strid31": `Saya telah membaca serta menyetujui Syarat dan Ketentuan di atas`,
    "strid32": "Tertunda",
    "strid33": "Disetujui",
    "strid34": "Gagal",
    "strid35": "Tanggal Pengajuan",
    "strid36": "Nama Turnamen",
    "strid37": "Tanggal Turnamen",
    "strid38": "Status",
    "strid39": "Pengajuan Anda berhasil dikirim.",
    "strid40": "Anda juga dapat",
    "strid41": "Menggunakan Alat Turnamen untuk mengumpulkan Player",
    "strid42": "Pertanyaan Umum",
    "strid43": "Kembali",
    "strid44": "Kode verifikasi telah dikirim",
    "strid45": `Apakah saya memerlukan lisensi untuk menyelenggarakan turnamen?
    Ya, Anda perlu mengajukan lisensi untuk menyelenggarakan kompetisi komunitas. Hal ini untuk memastikan pengalaman yang lebih baik bagi Anda dan juga peserta. Namun, apabila Prize Pool dari kompetisi Anda bernilai di bawah 5.000 USD, Anda dapat otomatis memperoleh perizinan setelah membaca S&K.
    Apakah terdapat batasan hadiah untuk kompetisi?
    Ya, jika Prize Pool Anda melebihi 5.000 USD, Anda harus mengajukan permohonan di situs Web. Pada saat yang sama, Anda akan memperoleh lebih banyak dukungan, termasuk akses ke Server eksklusif dengan semua Hero dan Emblem, logo dan sertifikat yang sah, serta promosi di sosial media resmi.
    Dapatkah saya menerima sponsor selama turnamen saya?
    Ya, tetapi kami memiliki panduan khusus mengenai sponsor. Silakan merujuk pada S&K untuk lebih lengkapnya.
    Jika turnamen saya bertabrakan jadwal dengan Event Esports besar MLBB, apakah saya masih memiliki kesempatan untuk mendapatkan perizinan?
    Apabila Prize Pool turnamen Anda di bawah 5.000 USD, kami tidak akan memaksa Anda untuk mengubah jadwal turnamen. Tetapi, apabila Prize Pool melebihi 5.000 USD, terdapat risiko untuk tidak mendapatkan perizinan resmi. Kami tetap menganjurkan untuk menyelenggarakan Event pada tanggal yang tidak bertabrakan dengan Event Esports besar MLBB.
    Apa yang akan terjadi jika saya menyelenggarakan turnamen tanpa lisensi?
    Anda berisiko mengakibatkan turnamen komunitas Anda diberhentikan, yang mana hal ini tidak memberikan pengalaman baik bagi Anda maupun peserta. Apabila Prize Pool Anda di bawah 5.000 USD, pastikan untuk membaca S&K dengan cermat. Jika Prize Pool Anda melebihi 5.000 USD, mohon ingat untuk mendapatkan perizinan resmi sebelum menyelenggarakan Event.`,
    "strid46":"Perizinan Lisensi Turnamen Besar Pihak Ketiga",
    "strid47":"Riwayat",
    "strid48":"FAQ",
    "strid49":"Menu Utama",
    "strid50":"Application History",
    "strid51":"Pilih Wilayah",
    "strid52":"WhatsApp/Instagram/Facebook/Email, dll.",
    "strid53":"Peran Anda",   
    "strid54":"Indonesia",
    "strid55":"Filipina",
    "strid56":"Malaysia",
    "strid57":"Brasil",
    "strid58":"Singapura",
    "strid59":"Myanmar",
    "strid60":"Kamboja",
    "strid61":"Rusia dan negara CIS lainnya",
    "strid62":"Turki",
    "strid63":"LATAM (Spanyol)",
    "strid64":"Timur Tengah dan Afrika Utara",
    "strid65":"Amerika Utara",
    "strid66":"Eropa",
    "strid67":"Wilayah",
    "strid68":"Lainnya",
    "strid69":`   
    Peraturan Umum untuk Perizinan Lisensi Turnamen oleh Pihak Ketiga "Mobile Legends: Bang Bang"
<br>
1. Ringkasan
<br>
Perizinan / Otorisasi ini digunakan untuk perusahaan / organisasi / individu (selanjutnya disebut sebagai "Anda") yang berencana untuk menyelenggarakan turnamen pihak ketiga "Mobile Legends: Bang Bang"; jika Anda mematuhi semua ketentuan dalam Otorisasi ini dan bersedia untuk mematuhi semua persyaratan Otorisasi ini, Otorisasi ini (yang merupakan Perjanjian hukum yang mengikat antara Moonton dan Anda) dapat digunakan untuk mengatur dan menyelenggarakan acara / turnamen pihak ketiga ("Turnamen").

Anda mengakui dan menyetujui bahwa:<br>

1) Shanghai Moonton Technology Co. Ltd. dan anak perusahaannya (selanjutnya disebut sebagai "Moonton") adalah pemilik logo Moonton, merek dagang, "Mobile Legends: Bang Bang" dan semua informasi dalam Game (termasuk namun tidak terbatas pada karakter, Skin, musik, Interface, gambar, Map dan Item, dll.) ("selanjutnya disebut sebagai Hak Kekayaan Intelektual (HKI) Moonton");
<br>
2) Ketika Anda menggunakan HKI Moonton, baik digunakan secara keseluruhan atau sebagian, Anda setuju untuk tidak menyebabkan gangguan atau kerusakan pada HKI Moonton dengan cara apa pun;
<br>
3) Tanpa izin tertulis dari Moonton, Anda tidak diizinkan untuk menggunakan HKI Moonton dalam hal apa pun selain Turnamen ini, dan Anda tidak diizinkan untuk mendaftarkan kekayaan intelektual yang mirip atau sama dengan HKI Moonton. Anda harus menggunakan nama yang terkait dengan HKI Moonton sebagai kata kunci untuk pencarian di Internet;
<br>
4) Kecuali untuk hak terbatas penggunaan HKI Moonton sebagaimana diizinkan dalam Otorisasi ini, Moonton tidak lagi memberikan hak lain, baik tersurat maupun tersirat.
<br><br>


2. Catatan Khusus
<br>
Otorisasi hanya akan berlaku jika Turnamen memenuhi persyaratan berikut dan Anda menyetujui dan menerima semua syarat dan ketentuan dalam Perjanjian ini.
<br>
Prize Pool minimum adalah 5.000 USD atau setara dengan Rp 70.000.000,- (tujuh puluh juta rupiah)

<br><br>



3. Peraturan Umum
<br>
3.1. Nama Turnamen
<br>
3.1.1. Kata "Liga" atau " League" tidak boleh digunakan dalam nama turnamen / nama Event / nama penyelenggara.
<br>
3.1.2. Anda tidak boleh memiliki nama yang sama atau mirip dengan event / turnamen resmi Moonton, termasuk namun tidak terbatas pada Mobile Legends: Bang Bang Professional League (MPL), Mobile Legends: Bang Bang Development League (MDL), Mobile Legends: Bang Bang Professional League Invitational (MPLI), Mobile Legends: Bang Bang Southeast Asia Cup (MSC), Mobile Legends: Bang Bang World Championship (M1, M2, M3), dll.
<br>
3.1.3. Kata-kata yang (1) membahayakan keamanan nasional, mengungkapkan rahasia negara, menumbangkan kekuasaan negara, atau merusak persatuan nasional; (2) membahayakan kehormatan dan kepentingan nasional, merusak kepentingan umum, atau menyebarkan kebencian etnis; (3) mengandung umpatan atau makian, termasuk kata-kata yang berpotensi menyinggung perasaan orang lain, kata-kata yang merusak nama baik pihak lain, kata-kata yang bersifat vulgar atau kebencian, atau kata-kata yang meresahkan lainnya; (4) berhubungan dengan pelecehan, pornografi, perjudian, obat-obatan terlarang, kekerasan, atau kegiatan kriminal; (5) mempromosikan aplikasi atau Game pihak ketiga; (6) merupakan nama tanpa izin yang hak ciptanya dipegang oleh individu atau organisasi lain yang tidak boleh dicantumkan dalam nama Turnamen;
<br>


3. 2. Penyelenggaraan Turnamen
<br>
3.2.1. Kecuali Anda telah mendapatkan izin dari Moonton, Anda tidak boleh mengadakan kompetisi Game MOBA Mobile lain selain "Mobile Legends: Bang Bang" dalam Turnamen.
<br>
3.2.2. Selama Mobile Legends: Bang Bang Professional League dan Mobile Legends: Bang Bang Development League, Anda tidak dapat melibatkan tim dan Player profesional yang aktif untuk berpartisipasi dalam bentuk apa pun.
<br>
3.2.3. Perusahaan atau organisasi yang menyediakan produk atau layanan yang menurut Moonton merugikan MPL atau dalam hubungan kompetitif dengan Mobile Legends: Bang Bang tidak boleh menjadi penyelenggara Turnamen.
<br>
3.2.4. Anda harus mengklarifikasi bahwa Turnamen ini didukung oleh E-project dan bukan mengklaim bahwa Turnamen ini disponsori atau diselenggarakan oleh Moonton. Logo "Moonton" tidak boleh ditampilkan di mana pun selama Turnamen berlangsung.
<br>
3.2.5. Dengan alasan untuk mematuhi semua hukum dan peraturan yang berlaku (termasuk persyaratan permukiman untuk kualifikasi), jika Player atau tim harus membayar biaya pendaftaran sebelum berpartisipasi dalam Turnamen, total bonus harus lebih besar atau sama dengan total biaya pendaftaran yang terkumpul.
<br>
3.2.6. Anda dilarang menampilkan hal-hal yang akan merusak citra atau nilai dari Moonton dan Mobile Legends: Bang Bang.
<br>
3.2.7. Turnamen harus bersifat tidak resmi. Anda bertanggung jawab atas masalah apa pun yang muncul. Moonton tidak bertanggung jawab atas hal tersebut.
<br>
3.2.8. Jadwal Turnamen harus menghindari bertabrakan jadwal dengan Turnamen resmi apa pun di wilayah tuan rumah dan jadwal Turnamen resmi apa pun di wilayah tim mana pun yang berpartisipasi. Jika setelah Turnamen disetujui, Moonton mengatur turnamen resmi baru di wilayah tersebut, Anda harus mengubah jadwal turnamen Anda. Jika tidak, Moonton akan membatalkan Otorisasi Turnamen dan meminta untuk menghentikan Turnamen.
<br>
3.2.9. Skala Turnamen harus sesuai dengan rancangan yang ditetapkan oleh Moonton.
<br>
3.2.10. Anda harus memberikan bonus atau hadiah lain kepada Player seperti yang dijanjikan.
<br>
3.2.11. Anda tidak diizinkan untuk menyiarkan Turnamen di stasiun televisi.
<br>
3.2.12. Anda setuju untuk memindahkan video atau rekaman video yang terkait dengan Turnamen kepada Moonton atau afiliasinya secara permanen tanpa dapat dibatalkan dan tanpa menerima biaya tambahan, dan untuk memberikan keuntungan dan manfaat global kepada Moonton atau afiliasinya (termasuk namun tidak terbatas pada hak kepemilikan dan hak kekayaan intelektual, dll.).
<br>
3.2.13. Moonton, sebagai pemilik video atau rekaman video Turnamen, dapat menyiarkan atau memutar ulang konten yang disebutkan di atas, dan dapat mengalihkan hak-hak di atas kepada pihak ketiga lainnya; Demikian juga, Moonton memiliki hak untuk memodifikasi konten video dan berhak untuk mempublikasikannya dalam bentuk apa pun atau dikomersialkan.
<br>
3.2.14. Anda memberikan jaminan kepada Moonton bahwa video atau rekaman video Turnamen apa pun tidak akan melanggar hak siapa pun, atau melanggar hukum dan peraturan setempat, dan tidak akan mengandung konten apa pun yang melanggar reputasi atau melibatkan pencemaran nama baik.
<br>
3.2.15. Anda dan tim yang berpartisipasi tidak boleh membeli atau menjual tiket atau berpartisipasi dalam Turnamen sebagai waralaba.
<br>
3.3. Pendapatan dan Pengeluaran
<br>
3.3.1. Perusahaan yang terlibat dalam penjualan atau promosi produk atau layanan berikut ini tidak boleh mensponsori Turnamen:
<br>
-Pornografi (atau konten dewasa ekstrim);
<br>
-Alkohol, ganja, dan obat-obatan terlarang;
<br>
-Tembakau atau afiliasinya (seperti PRO, Super atau LA Zone, dan lainnya.);
<br>
-Senjata api;
<br>
-Organisasi yang terlibat dalam perjudian;
<br>
3.3.2 Perusahaan atau organisasi yang menyediakan produk atau layanan yang menurut Moonton merugikan MPL atau dalam hubungan kompetitif dengan Game Mobile Mobile Legends: Bang Bang.
<br>
3.3.3. Turnamen tidak akan melibatkan perjudian dalam bentuk apa pun (termasuk lotere dan taruhan kompetitif virtual).
<br>
3.3.4 Event ini tidak disponsori / didukung oleh partai politik tertentu, atau organisasi yang berafiliasi dengan kepentingan politik / ras / etnis / agama tertentu.
<br>
3.3.5. Event ini mematuhi peraturan setempat (terutama yang berkaitan dengan protokol kesehatan).
<br>
3.3.6. Jika Anda ingin melakukan kegiatan urun dana untuk Turnamen, Anda harus menyatakan bahwa Turnamen dan kegiatan urun dana tidak ada hubungannya dengan Moonton. Dan keuntungan yang diperoleh melalui urun dana harus digunakan untuk Turnamen. Anda tidak boleh menyimpan hasil urun dana sebagai keuntungan.
<br>
3.3.7. Anda tidak diperbolehkan membuat atau menjual barang dagangan apa pun yang menampilkan Moonton dan merek atau unsur terkait atas nama Turnamen.
<br>
3.3.8. Anda tidak diperbolehkan menggunakan organisasi Turnamen dan acara terkait Turnamen untuk mendapatkan keuntungan, dan Anda tidak diperbolehkan untuk mendapatkan penghasilan yang menghasilkan keuntungan.
<br><br>


4. Lainnya
<br>
4.1. Jika Anda ingin menyelenggarakan Turnamen berdasarkan ketentuan Otorisasi ini, Anda harus mematuhi semua syarat dan ketentuan di sini. Jika Anda menjalankan Turnamen tanpa mendapatkan Otorisasi, Anda dianggap menyetujui syarat dan ketentuan yang tercantum dalam Perjanjian Otorisasi ini.
<br>
4.2. Anda setuju bahwa Moonton dapat meninjau pembukuan dan pencatatan Anda untuk memastikan bahwa Anda mematuhi ketentuan Perjanjian ini;
<br>
4.3. Jika terjadi perselisihan antara Anda dan Moonton, kami akan mencoba menyelesaikan perselisihan melalui negosiasi selama 30 hari dengan kedua belah pihak. Jika negosiasi gagal, sengketa apa pun akan diatur oleh hukum Singapura dan harus diajukan ke Pusat Arbitrase Internasional Singapura untuk diselesaikan.
<br>
4.4. Turnamen harus mematuhi semua hukum dan peraturan yang berlaku, serta kebijakan penyedia layanan dari pihak lain yang mungkin Anda gunakan; Dalam penyelenggaraan Turnamen, termasuk kegagalan Anda untuk mematuhi syarat dan ketentuan Otorisasi ini, yang disebabkan klaim atau tuntutan oleh pihak ketiga, Anda bertanggung jawab dan setuju untuk memberikan kompensasi kepada Moonton.
<br>
4.5. Persyaratan Otorisasi Turnamen hanya berlaku di wilayah Anda. Keputusan akhir dari Peraturan Umum ini adalah milik Moonton. Untuk hal-hal yang tidak tercakup, ketentuan resmi Turnamen akan berlaku. Moonton berhak untuk menyesuaikan dan mempublikasikan peraturan berdasarkan situasi nyata tanpa memberi tahu Anda.
<br>
4.6. Moonton berhak untuk membatalkan Turnamen dalam keadaan apa pun, dan tidak akan bertanggung jawab atas kerugian Anda.
     `
     ,
    "strid70":"Lainnya",
    "strid71":"Kode verifikasi telah dikirimkan ke alamat Email Anda {emails}. Silakan mengeceknya.",
    "strid72":"Total Prize Pool turnamen adalah (harap konversikan menjadi USD)",
    "strid73":`*Tidak perlu mengajukan untuk berbasis lisensi pada Prize Pool saat ini. Anda dapat menggunakan <a href="https://play.mobilelegends.com/match/#/" target="_blank">Alat Turnamen</a> untuk langsung menciptakan turnamen dan akan terlisensi secara otomatis.`,
  }
}

